export { default as BillPaymentHalfCard } from "./BillPaymentHalfCard";
export type {
    IBillPaymentHalfCardProps,
    IBillPaymentHalfCardContentProps,
    IBillPaymentCardData,
    IBillPaymentCTA,
} from "./types";
